module.exports = __webpack_public_path__ + "img/88.5e1fb482.jpg";